import React from "react";
import notFound from "../../../asset/404.png"
import {NavLink} from "react-router-dom";
import Link from "@material-ui/core/Link";

const NotFound = (props) => {

    return (

            <div className="main">
                <div className="container-fluid">
                    <div className="notFound">
                        <img src={notFound} alt=""/>
                        <h3>Страница не найдена</h3>
                        <Link component={NavLink} to="/lk/">Вернуться к списку объектов</Link>

                    </div>

                </div>
            </div>

    );
}

export default NotFound